import { render, staticRenderFns } from "./Candidates.vue?vue&type=template&id=444d5a06"
import script from "./Candidates.vue?vue&type=script&lang=js"
export * from "./Candidates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports